// + + + + + + + + + + + + + + + + + + + + + + + + + + + + + +
//
// FLOAT LABEL
// src : http://jsfiddle.net/RyanWalters/z9ymd852/
//
// + + + + + + + + + + + + + + + + + + + + + + + + + + + + + +

var fn_float_label = function () {
    // Date range not included, see date-range-field.js.
    $('.float-target, .float-target-parent input:not(input[type="date"]), .float-target-parent select').on('focus blur', function (e) {
        $(this).parents('.float-target-parent').removeClass('has-value');
        $(this).parents('.float-target-parent').toggleClass('focused', (e.type === 'focus' || this.value !== ''));
    });

    // Adding Focused on Label Input with a not empty value
    $('.float-target-parent input:not(input[type="date"])').each(function () {
        if( $.trim(this.value).length !== 0 ) {
            $(this).parents('.float-target-parent').addClass('focused');
        }
    });

    // Removing Focused on Label Input with an empty value
    $('.float-target-parent.focused input').each(function () {
        if( $.trim(this.value).length === 0 ) {
            $(this).removeAttr('value');
            $(this).parents('.float-target-parent').removeClass('focused');
        }

    });

    // Focusing Select with an option => selected
    $('.float-target-parent select option:selected').each(function () {
        $(this).parents('.float-target-parent').addClass('focused');
    });
    //
    $('.float-target-parent select').on('blur focusout', function (e) {
        if( $.trim(this.value).length === 0 && $(this).children('option').attr('selected') ) {
            $(this).parent('.float-target-parent').addClass('focused');
        }
    });

}
